/* eslint-disable max-len */
export const output_data = {
  ro_elements_DG: [
    {
      Name: 'MaxSDI',
      parameters: 'SDI15',
      condition: 'Max',
      unit:'',
      unitType:'',
      'Brackish Surfacewater (Conventional)': 5,
      'Brackish Surfacewater (MF/UF)': 3,
      'Brackish Wellwater': 3,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 2,
      'RO Permeate': 1,
      'Sea Wellwater': 3,
      'Surface Seawater (Conventional)': 5,
      'Surface Seawater (MF/UF)': 3,
      'Tertiary Treated Wastewater (Conventional)': 5,
      'Tertiary Treated Wastewater (MF/UF)': 3
    },
    {
      Name: 'MaxPermFlux',
      parameters: 'Permeate Flux',
      condition: 'Max Avg.',
      unitType:'flux',
      unit:'gfd',
      'Brackish Surfacewater (Conventional)': 14,
      'Brackish Surfacewater (MF/UF)': 18,
      'Brackish Wellwater': 18,
      'High pH RO (City/Well)': 30,
      'High pH RO 2nd Pass': 35,
      'High pH RO Wastewater': 25,
      'MBR Permeate': 14,
      'RO Permeate': 24,
      'Sea Wellwater': 12,
      'Surface Seawater (Conventional)': 10,
      'Surface Seawater (MF/UF)': 12,
      'Tertiary Treated Wastewater (Conventional)': 10,
      'Tertiary Treated Wastewater (MF/UF)': 12
    },
    {
      Name: 'LeadFluxMax',
      parameters: 'Permeate Flux',
      condition: 'Typical Range',
      unitType:'flux',
      unit:'gfd',
      'Brackish Surfacewater (Conventional)': '10-14',
      'Brackish Surfacewater (MF/UF)': '14-18',
      'Brackish Wellwater': '14-18',
      'High pH RO (City/Well)': '0-0',
      'High pH RO 2nd Pass': '0-0',
      'High pH RO Wastewater': '0-0',
      'MBR Permeate': '10-14',
      'RO Permeate': '18-24',
      'Sea Wellwater': '8-12',
      'Surface Seawater (Conventional)':'6-10',
      'Surface Seawater (MF/UF)': '8-12',
      'Tertiary Treated Wastewater (Conventional)': '6-10',
      'Tertiary Treated Wastewater (MF/UF)': '8-12'
    },
    {
      Name: 'LeadFluxMax',
      parameters: 'Lead Element Flux',
      condition: 'Max',
      unitType:'flux',
      unit:'gfd',
      'Brackish Surfacewater (Conventional)': 20,
      'Brackish Surfacewater (MF/UF)': 24,
      'Brackish Wellwater': 26,
      'High pH RO (City/Well)': 32,
      'High pH RO 2nd Pass': 40,
      'High pH RO Wastewater': 28,
      'MBR Permeate': 20,
      'RO Permeate': 30,
      'Sea Wellwater': 25,
      'Surface Seawater (Conventional)': 18,
      'Surface Seawater (MF/UF)': 25,
      'Tertiary Treated Wastewater (Conventional)': 16,
      'Tertiary Treated Wastewater (MF/UF)': 18
    },
    {
      Name: 'RecovertAt18',
      parameters: 'Element Recovery',
      condition: 'Max(flux >18 gfd)',
      unitType:'',
      unit:'',
      'Brackish Surfacewater (Conventional)': 15,
      'Brackish Surfacewater (MF/UF)': 15,
      'Brackish Wellwater': 15,
      'High pH RO (City/Well)': 40,
      'High pH RO 2nd Pass': 50,
      'High pH RO Wastewater': 33,
      'MBR Permeate': 15,
      'RO Permeate': 35,
      'Sea Wellwater': 15,
      'Surface Seawater (Conventional)': 15,
      'Surface Seawater (MF/UF)': 15,
      'Tertiary Treated Wastewater (Conventional)': 15,
      'Tertiary Treated Wastewater (MF/UF)': 15
    },
    {
      Name: 'RecoveryAt12',
      parameters: 'Element Recovery',
      condition: 'Max(flux <12 gfd)',
      unitType:'',
      unit:'',
      'Brackish Surfacewater (Conventional)': 20,
      'Brackish Surfacewater (MF/UF)': 20,
      'Brackish Wellwater': 22,
      'High pH RO (City/Well)': 40,
      'High pH RO 2nd Pass': 50,
      'High pH RO Wastewater': 33,
      'MBR Permeate': 20,
      'RO Permeate': 35,
      'Sea Wellwater': 20,
      'Surface Seawater (Conventional)': 20,
      'Surface Seawater (MF/UF)': 20,
      'Tertiary Treated Wastewater (Conventional)': 20,
      'Tertiary Treated Wastewater (MF/UF)': 20
    }, {
      Name: 'A',
      parameters: 'Flux, % annual decrease A(yr x)=B(yr 0)*(1-x*%/100)',
      condition: 'Default Value',
      unitType:'',
      unit:'',
      'Brackish Surfacewater (Conventional)': 5,
      'Brackish Surfacewater (MF/UF)': 3,
      'Brackish Wellwater': 3,
      'High pH RO (City/Well)': 3,
      'High pH RO 2nd Pass': 2,
      'High pH RO Wastewater': 5,
      'MBR Permeate': 5,
      'RO Permeate': 2,
      'Sea Wellwater': 4,
      'Surface Seawater (Conventional)': 7,
      'Surface Seawater (MF/UF)': 5,
      'Tertiary Treated Wastewater (Conventional)': 15,
      'Tertiary Treated Wastewater (MF/UF)': 10
    },
    {
      Name: 'B',
      parameters: 'Salt Passage, % annual increase B(yr x)=B(yr 0)*(1+x*%/100)',
      condition: 'Default Value',
      unitType:'',
      unit:'',
      'Brackish Surfacewater (Conventional)': 7,
      'Brackish Surfacewater (MF/UF)': 5,
      'Brackish Wellwater': 5,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 5,
      'RO Permeate': 2,
      'Sea Wellwater': 5,
      'Surface Seawater (Conventional)': 7,
      'Surface Seawater (MF/UF)': 5,
      'Tertiary Treated Wastewater (Conventional)': 15,
      'Tertiary Treated Wastewater (MF/UF)': 10
    },
    {
      Name: 'MaxFeedFlow16',
      parameters: 'Max Feed Flow',
      condition: '16" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 240,
      'Brackish Surfacewater (MF/UF)': 260,
      'Brackish Wellwater': 300,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 260,
      'RO Permeate': 300,
      'Sea Wellwater': 300,
      'Surface Seawater (Conventional)': 240,
      'Surface Seawater (MF/UF)': 260,
      'Tertiary Treated Wastewater (Conventional)': 200,
      'Tertiary Treated Wastewater (MF/UF)': 220
    },
    {
      Name: 'MaxFeedFlow8',
      parameters: 'Max Feed Flow',
      condition: '8" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 60,
      'Brackish Surfacewater (MF/UF)': 65,
      'Brackish Wellwater': 75,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 65,
      'RO Permeate': 75,
      'Sea Wellwater': 75,
      'Surface Seawater (Conventional)': 60,
      'Surface Seawater (MF/UF)': 65,
      'Tertiary Treated Wastewater (Conventional)': 50,
      'Tertiary Treated Wastewater (MF/UF)': 55
    },
    {
      Name: 'MaxFeedFlow4',
      parameters: 'Max Feed Flow',
      condition: '4" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 13,
      'Brackish Surfacewater (MF/UF)': 14,
      'Brackish Wellwater': 16,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 14,
      'RO Permeate': 16,
      'Sea Wellwater': 16,
      'Surface Seawater (Conventional)': 13,
      'Surface Seawater (MF/UF)': 14,
      'Tertiary Treated Wastewater (Conventional)': 11,
      'Tertiary Treated Wastewater (MF/UF)': 12
    },
    {
      Name: 'MaxFeedFlow2.5',
      parameters: 'Max Feed Flow',
      condition: '2.5" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 4,
      'Brackish Surfacewater (MF/UF)': 5,
      'Brackish Wellwater': 6,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 5,
      'RO Permeate': 6,
      'Sea Wellwater': 6,
      'Surface Seawater (Conventional)': 4,
      'Surface Seawater (MF/UF)': 5,
      'Tertiary Treated Wastewater (Conventional)': 4,
      'Tertiary Treated Wastewater (MF/UF)': 4
    },
    {
      Name: 'MinConcFlow16',
      parameters: 'Min Conc. Flow',
      condition: '16" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 40,
      'Brackish Surfacewater (MF/UF)': 40,
      'Brackish Wellwater': 32,
      'High pH RO (City/Well)': 56,
      'High pH RO 2nd Pass': 40,
      'High pH RO Wastewater': 80,
      'MBR Permeate': 40,
      'RO Permeate': 32,
      'Sea Wellwater': 40,
      'Surface Seawater (Conventional)': 40,
      'Surface Seawater (MF/UF)': 40,
      'Tertiary Treated Wastewater (Conventional)': 40,
      'Tertiary Treated Wastewater (MF/UF)': 40
    },
    {
      Name: 'MinConcFlow8',
      parameters: 'Min Conc. Flow',
      condition: '8" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 10,
      'Brackish Surfacewater (MF/UF)': 10,
      'Brackish Wellwater': 8,
      'High pH RO (City/Well)': 14,
      'High pH RO 2nd Pass': 10,
      'High pH RO Wastewater': 20,
      'MBR Permeate': 10,
      'RO Permeate': 8,
      'Sea Wellwater': 10,
      'Surface Seawater (Conventional)': 10,
      'Surface Seawater (MF/UF)': 10,
      'Tertiary Treated Wastewater (Conventional)': 10,
      'Tertiary Treated Wastewater (MF/UF)': 10
    },
    {
      Name: 'MinConcFlow4',
      parameters: 'Min Conc. Flow',
      condition: '4" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 2,
      'Brackish Surfacewater (MF/UF)': 2,
      'Brackish Wellwater': 2,
      'High pH RO (City/Well)': 4,
      'High pH RO 2nd Pass': 2,
      'High pH RO Wastewater': 5,
      'MBR Permeate': 2,
      'RO Permeate': 2,
      'Sea Wellwater': 2,
      'Surface Seawater (Conventional)': 2,
      'Surface Seawater (MF/UF)': 2,
      'Tertiary Treated Wastewater (Conventional)': 2,
      'Tertiary Treated Wastewater (MF/UF)': 2
    },
    {
      Name: 'MinConcFlow2.5',
      parameters: 'Min Conc. Flow',
      condition: '2.5" elem',
      unitType:'flow',
      unit:'gpm',
      'Brackish Surfacewater (Conventional)': 0.6,
      'Brackish Surfacewater (MF/UF)': 0.6,
      'Brackish Wellwater': 0.6,
      'High pH RO (City/Well)': 0,
      'High pH RO 2nd Pass': 0,
      'High pH RO Wastewater': 0,
      'MBR Permeate': 0.6,
      'RO Permeate': 0.6,
      'Sea Wellwater': 0.6,
      'Surface Seawater (Conventional)': 0.6,
      'Surface Seawater (MF/UF)': 0.6,
      'Tertiary Treated Wastewater (Conventional)': 0.6,
      'Tertiary Treated Wastewater (MF/UF)': 0.6
    }
  ],
  firstHeader: [
    {
      hdata: 'Water Source',
      colspan: 3
    },
    {
      hdata: 'RO Permeate',
      colspan: 0
    },
    {
      hdata: 'Brackish Well water',
      colspan: 0
    },
    {
      hdata: 'Brackish Surface water',
      colspan: 2
    },
    {
      hdata: 'Seawater Well',
      colspan: 0
    },
    {
      hdata: 'Surface Seawater',
      colspan: 2
    },
    {
      hdata: 'Tertiary Treated Wastewater',
      colspan: 2
    },
    {
      hdata: 'MBR Permeate',
      colspan: 0
    },
    // {
    //   hdata: 'High pH RO',
    //   colspan: 3
    // }
  ],
  secoundHeader: [
    {
      hdata: 'Pre-Treatment',
      colspan: 0
    },
    {
      hdata: '',
      colspan: 0
    },
    {
      hdata: '',
      colspan: 0
    },
    {
      hdata: 'RO',
      colspan: 0
    },
    {
      hdata: '',
      colspan: 0
    },
    {
      hdata: 'MF/UF',
      colspan: 0
    },
    {
      hdata: 'Conve- ntional',
      colspan: 0
    },
    {
      hdata: '',
      colspan: 0
    },
    {
      hdata: 'MF/UF',
      colspan: 0
    },
    {
      hdata: 'Conve- ntional',
      colspan: 0
    },
    {
      hdata: 'MF/UF',
      colspan: 0
    },
    {
      hdata: 'Conve- ntional',
      colspan: 0
    },
    {
      hdata: 'MBR',
      colspan: 0
    },
    // {
    //   hdata: 'City/ Well',
    //   colspan: 0
    // },
    // {
    //   hdata: 'Waste Water',
    //   colspan: 0
    // },
    // {
    //   hdata: '2nd Pass',
    //   colspan: 0
    // }
  ],
  thirdHeader: [
    {
      hdata: 'Parameters',
      colspan: 0
    },
    {
      hdata: 'Condition',
      colspan: 0
    },
    {
      hdata: 'Unit',
      colspan: 0
    },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    { hdata: '', colspan: 0 },
    // { hdata: '', colspan: 0 },
    // { hdata: '', colspan: 0 },
    // { hdata: '', colspan: 0 }
  ],
  units: [
    { unit:['']},
    { unit:['gfd', 'lmd', 'lmh', 'm/s', 'm/hr']},
    { unit:['gfd', 'lmd', 'lmh', 'm/s', 'm/hr']},
    { unit:['gfd', 'lmd', 'lmh', 'm/s', 'm/hr']},
    { unit:['%']},
    { unit:['%']},
    { unit:['%']},
    { unit:['%']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
    { unit: ['gpm', 'gph', 'gpd', 'Bbl/hr', 'Bbl/day', 'l/s', 'ft3/s', 'ft3/hr', 'ft3/day', 'ft3/min', 'm3/s', 'm3/hr', 'm3/day', 'l/min', 'l/hr']},
  ]
};
